import { Component, Inject } from "@angular/core";
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { MatTableCrudEditComponent } from "../../../shared/components/mat-table-crud/mat-table-crud-edit.component";
import { MatTableCrudService } from "../../../shared/components/mat-table-crud/mat-table-crud.service";
import { AuthorisationService } from "../../../shared/services/authorisation.service";
import { CommonDataService } from "../../../shared/services/common-data.service";
import { CommonService } from "../../../shared/services/common.service";
import { LoggerService } from "../../../shared/services/logger.service";
import { CategoryExclusivity, Client } from "../../calendars/calendars.models";
import { AdministrationService } from '../administration.service';
import { GenericFilterPipe } from "../../../shared/pipes/generic-filter.pipe";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";

import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";
import { ComboBoxModule, PopupSettings as ddlPopupSettings } from '@progress/kendo-angular-dropdowns';
import { FloatingLabelModule } from '@progress/kendo-angular-label';


@Component({
    templateUrl: './category-exclusivity-edit.component.html',
    selector: 'category-exclusivity-edit-form',
    styleUrls: ['../../../shared/components/mat-table-crud/mat-table-crud.component.scss', './category-exclusivities.component.scss'],
    providers: [MatTableCrudService],
    standalone: true,
    imports: [CdkDrag, FormsModule, ReactiveFormsModule, CdkDragHandle, MatDialogTitle, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatDatepickerModule, MatCheckboxModule, MatDialogActions, MatButtonModule, GenericFilterPipe, ComboBoxModule, FloatingLabelModule]
})
export class CategoryExclusivityEditComponent extends MatTableCrudEditComponent<CategoryExclusivityEditComponent, CategoryExclusivity>
{
  constructor(public fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<CategoryExclusivityEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CategoryExclusivity,
    public administrationService: AdministrationService,
    public commonDataService: CommonDataService,
    public commonService: CommonService,
    public authorisationService: AuthorisationService,
    public loggerService: LoggerService)
  {
    super(dialogRef, data);

    if (this.data.StartDate)
    {
      this.data.StartDate = this.commonService.parseJsonDate(this.data.StartDate);
    }
    if (this.data.EndDate)
    {
      this.data.EndDate = this.commonService.parseJsonDate(this.data.EndDate);
    }

    this.form = this.fb.group({
      Id: [this.data.Id],
      PodcastId: [this.data.PodcastId, Validators.required],
      ClientId: [this.data.ClientId, Validators.required],
      ProductCategoryId: [this.data.ProductCategoryId, Validators.required],
      StartDate: [this.data.StartDate, Validators.required],
      EndDate: [this.data.EndDate, Validators.required],
      Disabled: [this.data.Disabled]
    });
  }

  // Same virtual/filterable kendo-combobox pattern used by activity.component.ts for the
  // Client dropdown, so opening the dialog and the dropdown itself stay fast even with a
  // very large client list.
  public clients: Client[] = [];

  public virtual: any = {
    itemHeight: 28,
  };

  public comboBoxPopupSettings: ddlPopupSettings = {
    popupClass: 'popup-class-category-exclusivity'
  };

  public handleClientsFilter(query: string): void
  {
    const activeClients = (this.commonDataService.clients() ?? []).filter(c => !c.Disabled);
    const predicate = (item: Client) => item.Name.toLowerCase().indexOf(query.toLowerCase()) >= 0;

    this.clients = query ? activeClients.filter(predicate) : activeClients;
  }

  ngOnInit()
  {
    super.ngOnInit();

    this.clients = (this.commonDataService.clients() ?? []).filter(c => !c.Disabled);
  }

  onSave(): void
  {
    const categoryExclusivity: any = this.form.value;

    if (categoryExclusivity)
    {
      if (this.isNew)
      {
        categoryExclusivity.Id = 0;

        if (categoryExclusivity.Disabled == null)
        {
          categoryExclusivity.Disabled = false;
        }
      }

      // Shift local midnight to UTC midnight so the service receives the selected calendar day,
      // otherwise JSON serialisation sends the previous day (e.g. 31 Oct AEDT => 30 Oct 13:00Z).
      categoryExclusivity.StartDate = this.commonService.formatDateForService(categoryExclusivity.StartDate);
      categoryExclusivity.EndDate = this.commonService.formatDateForService(categoryExclusivity.EndDate);

      super.onSave(categoryExclusivity);
    }
  }

  get dialogHeaderText(): string
  {
    let headerText = "Edit Category Exclusivity";

    if (this.isNew)
    {
      headerText = "New Category Exclusivity";
    }
    else
    {
      if (this.showEditItemNameInHeaderText)
      {
        headerText = `${headerText} - ${this.data.PodcastName}/${this.data.ClientName}/${this.data.ProductCategoryName}`;
      }
    }

    return headerText;
  }

  ngOnDestroy()
  {
    super.ngOnDestroy();
  }
}
